<!--
/*******************************************************************************
*@ 화면명   : PermissionPopup.vue
*@ 화면설명 : 권한요청 팝업
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2023.09.07  최지영   신규
********************************************************************************/

-->
<template>
  <section>
    <!-- modal -->
    <modal-pop :opened.sync="this.permissionChk.data == '0'" :modalHeader="true" :modalFooter="true" title="MMAIN-05-01-01-01" class="modal access-info">
      <template #content>
        <div class="info-tit">{{ /*KB Global Star Banking 앱에서는 다음 권한이 필요합니다. 필수권한은 반드시 허용해주세요.*/ $t("MMAIN-05-01-01-02") }}</div>
        <div class="info-cont">
          <p class="info-cont-tit">{{ /*필수 접근 권한*/ $t("MMAIN-05-01-01-03") }}</p>
          <div class="info-cont-item">
            <p class="item-01">
              <i class="icon icon-save" />
              {{ /*저장 공간*/ $t("MMAIN-05-01-01-04") }}
            </p>
            <p class="item-02">{{ /*상품 약관, 공지/뉴스 첨부파일 다운로드*/ $t("MMAIN-05-01-01-05") }}</p>
          </div>
          <p class="info-cont-tit">{{ /*선택적 접근 권한*/ $t("MMAIN-05-01-01-06") }}</p>

          <div class="info-cont-item">
            <p class="item-01">
              <i class="icon icon-camera" />
              {{ /*카메라*/ $t("MMAIN-05-01-01-07") }}
            </p>
            <p class="item-02">{{ /*QR코드 촬영, 신분증 촬영 등 생체정보등록/검증*/ $t("MMAIN-05-01-01-08") }}</p>
          </div>
          <div class="info-cont-item">
            <p class="item-01">
              <i class="icon icon-photo-gallery" />
              {{ /*사진 갤러리*/ $t("MMAIN-05-01-01-09") }}
            </p>
            <p class="item-02">{{ /*QR코드 업로드*/ $t("MMAIN-05-01-01-10") }}</p>
          </div>
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="confirm()">{{ /*확인*/ $t("MPRS-01-01-01-07") }}</button>
      </template>
    </modal-pop>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
//import { mapActions } from "vuex";
export default {
  name: "PermissionPopup",
  computed: {
    ...mapFields("native", ["permissionChk", "popupShow"]),
    // ...mapActions("accessPerm")
  },
  mounted() {},
  data() {
    return {
      openPopup: false,
    };
  },
  methods: {
    confirm() {
      this.permissionChk.data = "1"; // grant permission & popup closed
      //리스트에 있는 권한 허용 요청
      var permissions = ["1", "2"]; // 1: cam, 2: photo
      // 확인버튼 눌렀을 때,,, permissionChk.data -> 1로 주면서 퍼미션
      this.$bridge.requestPermissions(permissions);
      // this.$bridge.qrScanForTransfer(this.operGroupCd);
    },
  },
};
</script>
